import React from 'react';

export const createSocialMediaTags = () => (
    <>
        <meta property="fb:app_id" content={process.env.FACEBOOK_APP_ID} />
        <meta name="twitter:card" content="summary" key="twitterSummary" />
        <meta name="twitter:title" content="Fairygodboss" key="twitterTitle" />
        <meta name="twitter:site" content="@fairygodboss" key="twitterSite" />
        <meta
            name="twitter:creator"
            content="@fairygodboss"
            key="twitterCreator"
        />
        <meta
            name="twitter:image:height"
            content="418"
            key="twitterImageHeight"
        />
        <meta
            name="twitter:image:width"
            content="800"
            key="twitterImageWidth"
        />
        <meta
            name="twitter:description"
            content="Company Reviews for Women"
            key="twitterDescription"
        />
        <meta
            name="twitter:image"
            content="https://res.cloudinary.com/fairygodboss/image/upload/v1681846562/articles_upload/content/bepbejxmscgrncvwbzsb.webp"
            key="twitterImage"
        />
        <meta property="og:type" content="article" />
        <meta
            property="og:image"
            content="https://res.cloudinary.com/fairygodboss/image/upload/v1681846562/articles_upload/content/bepbejxmscgrncvwbzsb.webp"
        />
    </>
);

export const createMetaTags = () => (
    <>
        <meta charSet="utf-8" />
        <meta name="application-name" content="Fairygodboss" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="robots" content="index,follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
            name="keywords"
            content="Jobs and company reviews by women, for women | Fairygodboss"
        />
        <meta
            name="google-site-verification"
            content="oNYMpG6PBkvJGNNBI0yZ8Lrb9GdvJczImLat8NQEHX8"
        />
        <meta name="msvalidate.01" content="9D58CAD1C532572C633D62624F20F702" />
        <meta
            name="p:domain_verify"
            content="7ad6ff4b66cfa84eefb9509c3e7cafed"
        />

        <meta property="og:locale" content="en_US" />

        <meta property="og:url" content="Article Career Topics URL" />

        <meta
            property="og:image:alt"
            content="Fairygodboss - A Career Community for Women"
        />

        <meta property="og:image:width" content="600" />

        <meta property="og:image:height" content="315" />

        <meta property="og:site_name" content="Fairygodboss" />

        <meta
            property="og:see_also"
            content="https://github.com/fairyGodBoss/"
        />

        <meta
            property="og:see_also"
            content="https://www.instagram.com/fairygodboss/"
        />

        <meta
            property="og:see_also"
            content="https://www.pinterest.com/fairygodboss/"
        />

        <meta
            property="og:see_also"
            content="https://twitter.com/fairygodboss"
        />

        <meta
            property="og:see_also"
            content="https://www.facebook.com/fairygodboss/"
        />

        <meta
            property="og:see_also"
            content="https://www.linkedin.com/company/fairygodboss/"
        />

        <meta
            property="og:see_also"
            content="https://www.youtube.com/channel/UCA_fbeNmeWwMtbQwF7gjMXg"
        />
    </>
);

export const createPreloadTags = () => (
    <>
        <link
            rel="preload"
            href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
            as="style"
            onLoad="this.onload=null;this.rel='stylesheet'"
        />
        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <link rel="preconnect" href="https://www.google-analytics.com" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="true"
        />
        <link rel="preconnect" href="https://d207ibygpg2z1x.cloudfront.net" />
    </>
);
export default function SEO() {
    return (
        <>
            {createMetaTags()}
            {createSocialMediaTags()}
            {createPreloadTags()}
        </>
    );
}
